import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "./main.css"
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

import router from './router/index'

Vue.config.productionTip = false
Vue.use(ElementUI)

const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: 'https://zymebalanz.com/ZHRAPI/setting/'
})

const cache = new InMemoryCache()
const apolloClient = new ApolloClient({
  // You should use an absolute URL here
  cache,
  link: httpLink
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

export default new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
